import React from 'react'

import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { FormField } from '@/components/forms/FormField'
import { TextArea as TextAreaInput } from '@/components/forms/TextArea'

import { getFieldErrorMessage } from './formik.helpers'

export const TextArea = ({
  label,
  errorMessage,
  field: { name, value, ...fieldProps },
  form: { touched, errors },
  required,
  ...props
}) => {
  const error = getFieldErrorMessage({ errorMessage, errors, touched, name })

  return (
    <FormField required={required} error={Boolean(error)}>
      {label && <label htmlFor={name}>{label}</label>}
      <TextAreaInput
        data-testid={`textArea-${name}`}
        id={name}
        name={name}
        value={value ?? ''}
        error={Boolean(error)}
        {...fieldProps}
        {...props}
      />
      {error && <ErrorMessage content={error} />}
    </FormField>
  )
}
